import { motion } from 'framer-motion';
import Footer from '../components/Footer';

const AgronomyPage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <div>
      <section className="pt-32 pb-20 bg-gradient-to-br from-tev-green to-tev-green-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-5xl font-bold mb-6">Agronomy</h1>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              Excellence in agricultural production and farm management
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="space-y-16"
          >
            {/* Overview */}
            <motion.div variants={itemVariants} className="text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Agronomy Operations</h2>
              <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
                Our Agronomy division forms the foundation of TEV Group's operations, managing both our own commercial farming 
                activities and providing comprehensive support to our network of outgrower farmers. We focus on sustainable 
                agricultural practices, quality seed production, and efficient irrigation management to ensure consistent, 
                high-quality crop yields.
              </p>
            </motion.div>

            {/* Key Services */}
            <motion.div variants={itemVariants}>
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Our Core Services</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl">
                  <div className="flex items-center mb-4">
                    <div className="bg-green-600 text-white p-3 rounded-full mr-4">
                      <i className="fas fa-seedling text-xl"></i>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900">Seed Production</h4>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    High-quality seed multiplication and distribution of improved varieties for beans, maize, peanuts, 
                    pigeon peas, and cassava, ensuring genetic purity and certification standards.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-xl">
                  <div className="flex items-center mb-4">
                    <div className="bg-blue-600 text-white p-3 rounded-full mr-4">
                      <i className="fas fa-tint text-xl"></i>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900">Irrigation Services</h4>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Water-efficient irrigation systems without upfront costs, providing expert management and maintenance 
                    to maximize water efficiency for farmers.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Featured Image */}
            <motion.div variants={itemVariants} className="relative">
              <img 
                src="/images/seeds.jpg" 
                alt="Agronomy Operations" 
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent rounded-2xl"></div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AgronomyPage;
